'use strict';

require('./vendor');

import fullpage from 'fullpage.js';
import 'owl.carousel';

$(document).ready(function() {
	// Alle JS komt hier
	var windowWidth = $(window).width();

	if (windowWidth < 350) {
		var isSmall = true;
	} else {
		var isSmall = false;
	}

	if (windowWidth < 768) {
		var isMobile = true;
	} else {
		var isMobile = false;
	}

	if ($('video').length > 0) {
		const videoEl = document.querySelector('video')
		videoEl.muted = true
		videoEl.loop = true
		videoEl.play()
	}

	// Nu simpele loader weghalen bij dom ready
	$('.loader').hide();

	// Menu
	$('.menu-button').click(function(e) {
		e.preventDefault();
		$('body').toggleClass('menu-open');
		$('.popup').fadeOut();

		if ($('body').hasClass('menu-open')) {
			if ($('#fp-nav').length) {
				$('#fp-nav').fadeOut();

				if (!isMobile) {
					fullpage_api.setAllowScrolling(false);
					fullpage_api.setKeyboardScrolling(false);
				}
			}
		} else {
			if ($('#fp-nav').length) {
				$('#fp-nav').fadeIn();

				if (!isMobile) {
					fullpage_api.setAllowScrolling(true);
					fullpage_api.setKeyboardScrolling(true);
				}
			}
		}
	});

	function headerWhiteBottom() {
		var top = $('html,body').scrollTop();
		if (top >= $(window).height()) {
			top = $(window).height();
		}
		var top2 = top * -1;
		$('.white-bottom').css('top', top2);
	}

	function showItems() {
		$('.animate, .button').each(function(_, e) {
			if ($(e).offset().top < $(window).scrollTop() + $(window).height() / 1) {
				$(e).addClass('show');
			}
		});
	}

	function updateScroll() {
		var body = document.querySelector('body');

		if ($(window).scrollTop() > 1) {
			body.classList.add('scrolled');
		} else {
			body.classList.remove('scrolled');
		}
	}

	$('.icon-arrow').click(function(e) {
		e.preventDefault();
		fullpage_api.moveSectionDown();
	});

	// showItems();

	// Scroll
	$(window).scroll(function() {
		headerWhiteBottom();
		updateScroll();
		showItems();
	});

	// Homepage
	$('.slide-title-home h1')
		.delay(1000)
		.queue( function(next){
			$(this).css('opacity', '1');
		next();
	});

	if(!isSmall){
		if ($('body.slide1-active').length > 0) {
			$('.slide-title-home h1').each(function(index) {
				var characters = $(this).text().split("");
				var $this = $(this);
				$this.empty();
				$.each(characters, function(i, el) {
					if (el === ' ') {
						$this.append("<span class='space'>" + el + "</span");
					} else {
						$this.append("<span>" + el + "</span");
					}
				});
			});
		}
	}

	// Voor jezelf, voor organisaties, voor professionals
	if ($('body.slide2-active, body.slide3-active, body.slide4-active').length > 0) {
		if(!isMobile){
			setTimeout(function() {
				$('.slide-title h6').each(function(index) {
					var characters = $(this).text().split("");
					var $this = $(this);
					$this.empty();
					$.each(characters, function(i, el) {
						if (el === ' ') {
							$this.append("<span class='space'>" + el + "</span");
						} else {
							$this.append("<span>" + el + "</span");
						}
					});
				});
			}, 1500);
		}

		setTimeout(function() {
			$('.section.header .fp-tableCell').addClass('background-animation');
		}, 750);
	}

	// Aanmelden training
	$(document).on('click', 'input[name="form_aanmelden_training_invoice"]', function() {
		$('.invoice-fields').toggle();
	});

	// Owl carousel
	if ($('.owl-carousel').length > 0) {
		$('.owl-carousel').owlCarousel({
			items: 1,
			dots: true,
			loop: true,
			autoplay: true,
			autoplayHoverPause: true,
			autoplayTimeout: 7000,
		});
	}

	var fullpage_api = new fullpage('#fullpage', {
		//options here
		animateAnchor:false,
		scrollBar: false,
		scrollOverflow: false,
		normalScrollElements: 'nav, .overlay, .popup',
		menu: '#menu',
		navigation: true,
		responsiveWidth: 768,
		licenseKey: 'E431AA56-1CED4DB6-97D0396B-C45CB7BE',
		afterLoad: function(origin, destination, direction){
			//icon minimaliseren op fullpage
			if($('body').hasClass('fp-viewing-home')){
				$('body').removeClass('scrolled');
			}else{
				$('body').addClass('scrolled');
			}
		},
	});
});

$(document).foundation();

if (module.hot) {
	module.hot.accept()
}
